<span class="statusBox" [ngClass]="stateClass">{{ stateName }}</span>